import React,{forwardRef} from 'react';
const {prefixCSS} = polyphony.css;

const ArrowButton = forwardRef(({children, href, onClick, style, duotone = false, tag: Tag='a'}, ref) => {
    return <Tag ref={ref} style={{display: 'table', ...style}} href={href} onClick={onClick}>
        <div role='none' style={prefixCSS({display: 'flex', alignItems: 'center', padding: 10,
                     boxSizing: 'border-box', width: 'fit-content',
                     background: '#f1f1f1', borderRadius: 3,
                     color: 'black'})}>
            <span style={{fontSize: 20, lineHeight: 1}}>{children}</span>
            <svg role='none' height={20} width={20} viewBox="0 0 320 512">
                <path fill="currentColor" d="M188.74 256l56.78 56.89L91.21 466.9a24 24 0 0 1-33.94 0l-22.7-22.65a23.93 23.93 0 0 1 0-33.84z" style={duotone ? {opacity: 0.3} : {}} />
                <path fill="currentColor" d="M91.25 45.06l194.33 194a23.93 23.93 0 0 1 0 33.84l-40 40-211-211.34a23.92 23.92 0 0 1 0-33.84l22.7-22.65a24 24 0 0 1 33.97-.01z" />
            </svg>
        </div>
    </Tag>;
});

ArrowButton.displayName = 'ArrowButton';

export default ArrowButton;

